import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import CarouselViewAllLink from 'components/Common/CarouselViewAllLink'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const filters: App.OfferListFilters = {
  cruiseTypes: ['RIVER'],
}

function CruisePageRiverCruisesCarousel() {
  const intl = useIntl()
  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const viewAllLabel = intl.formatMessage({
    id: 'EHVd_nMk7jtYxZbTa9Hj',
    defaultMessage: 'View all',
    description: 'Button text to view all river cruise offers in the cruise section',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="S5a1bk-EapyGHGyJtwIq"
            defaultMessage="River <i>cruises</i>"
            description="Section heading for river cruise offers in the cruise offer or booking section"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <CarouselViewAllLink
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
        >
          {viewAllLabel}
        </CarouselViewAllLink>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageRiverCruisesCarousel
